import {
  BORDER_STYLE_BOX,
  FLEX_ALIGN_BOTTOM,
  FLEX_ALIGN_MIDDLE,
  FLEX_ALIGN_START,
  FLEX_SPACE_BETWEEN,
  ContentFlexAlignment,
} from 'global/constants';
import { ColumnProperties, ColumnStyle } from './column-settings.constants';
import { ComponentColumn } from '../../component.constants';
import { removeTypenameFromObject } from 'approot/shared/logic/remove-typename';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { COLUMN_COLOURS } from '../columns.constants';

export function isBorderApplied(
  style: ColumnStyle | null | undefined
): boolean {
  return style?.border === BORDER_STYLE_BOX;
}

export function isBackgroundApplied(
  style: ColumnStyle | null | undefined
): boolean {
  return !!style?.backgroundColour;
}

export function getAppliedColour(
  style: ColumnStyle | null | undefined
): ColourItem | undefined {
  return COLUMN_COLOURS.find(c => c.base === style?.baseColour);
}

export function getAlignmentLabel(
  alignment: ContentFlexAlignment | null
): string {
  if (alignment === FLEX_ALIGN_START) {
    return 'Top aligned';
  } else if (alignment === FLEX_ALIGN_BOTTOM) {
    return 'Bottom aligned';
  } else if (alignment === FLEX_ALIGN_MIDDLE) {
    return 'Middle aligned';
  } else if (alignment === FLEX_SPACE_BETWEEN) {
    return 'Spaced evenly';
  }
  return '';
}

export function getAlignmentIcon(alignment: ContentFlexAlignment | null) {
  switch (alignment) {
    case FLEX_SPACE_BETWEEN:
      return 'icon_align_distribute';
    case FLEX_ALIGN_BOTTOM:
      return 'icon_align_bottom';
    case FLEX_ALIGN_MIDDLE:
      return 'icon_align_middle';
    default:
      return 'icon_align_top';
  }
}

export function getColumnLayoutProperties(
  style: ColumnStyle,
  columnProperties: ColumnProperties | null,
  isColumnUpdate: boolean
) {
  if (isColumnUpdate) {
    return columnProperties?.style ?? null;
  }
  return removeTypenameFromObject(style);
}

export function getColumnsProperties({
  style,
  applyToAll,
  columnId,
  columns,
}: {
  style: ColumnStyle;
  applyToAll?: boolean;
  columnId?: string;
  columns: ComponentColumn[];
}) {
  return columns.map(column => {
    const columnStyle =
      applyToAll || columnId === column.columnId ? style : column.style;

    return {
      colspan: column.colspan,
      alignment: column.alignment,
      style: columnStyle ? removeTypenameFromObject(columnStyle) : columnStyle,
      index: column.index,
      columnId: column.columnId,
    };
  });
}

export function getColumnsColumnPayload(columns: ComponentColumn[] | null) {
  if (!columns) return [];

  return columns.map(column => {
    const { __typename, language, components, ...rest } = column;
    return {
      ...rest,
      style: rest.style ? removeTypenameFromObject(rest.style) : column.style,
    };
  });
}
